export default {
  listImageUrlAltText: 'List Image',
};
